import { render, staticRenderFns } from "./SonlineLink.vue?vue&type=template&id=36a34402&scoped=true"
import script from "./SonlineLink.vue?vue&type=script&lang=js"
export * from "./SonlineLink.vue?vue&type=script&lang=js"
import style0 from "./SonlineLink.vue?vue&type=style&index=0&id=36a34402&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a34402",
  null
  
)

export default component.exports